import { render, staticRenderFns } from "./r-plinko-ball-config.vue?vue&type=template&id=5ab5cb34"
import script from "./r-plinko-ball-config.vue?vue&type=script&lang=js"
export * from "./r-plinko-ball-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab5cb34')) {
      api.createRecord('5ab5cb34', component.options)
    } else {
      api.reload('5ab5cb34', component.options)
    }
    module.hot.accept("./r-plinko-ball-config.vue?vue&type=template&id=5ab5cb34", function () {
      api.rerender('5ab5cb34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-ball-config.vue"
export default component.exports